export default __webpack_public_path__ + "static/media/medical-q-icon-active.e0a49429.svg";